import { Link } from 'react-router-dom';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-grid-line',
      title: 'Product Categories',
      desc: 'Explore organized categories including shoes, clothing, accessories, and more — all structured for effortless browsing.',
    },
    {
      icon: 'ri-book-open-line',
      title: 'Buying Guides',
      desc: 'Learn how to choose products smarter with step-by-step guidance, comparison tips, and expert shopping strategies.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety Resources',
      desc: 'Understand safe browsing and shopping practices, including how to verify sellers and protect your personal information.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Comparison Tools',
      desc: 'Compare product options side by side before making decisions, saving time and helping you find the best value.',
    },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            Explore Resources
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 text-balance">
            Everything You Need Before Shopping
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            From <strong>vigorbuy product spreadsheet</strong> browsing to <strong>vigorbuy shopping guide</strong> tips, every tool you need is right here.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f) => (
            <div key={f.title} className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300">
              <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${f.icon} text-accent-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{f.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors whitespace-nowrap"
          >
            View all resources <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}